function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".search-icon-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Landing_w_Project",
  "data-name": "Landing w/ Project"
}, /*#__PURE__*/React.createElement("path", {
  className: "search-icon-1",
  d: "M12.08,10.94h0l-.83-.84C10.31,9,10.73,8.57,11,7.71a4.83,4.83,0,0,0,.16-1.15,4.56,4.56,0,1,0-4.55,4.55A5,5,0,0,0,7.72,11a2.46,2.46,0,0,1,2.4.29l.71.68,1.29,1.29,1.12-1.11ZM6.56,9.66a3.1,3.1,0,1,1,3.1-3.1A3.1,3.1,0,0,1,6.56,9.66Z",
  transform: "translate(-2 -2)"
}), /*#__PURE__*/React.createElement("path", {
  className: "search-icon-1",
  d: "M6.56,2a4.56,4.56,0,1,0,0,9.11A5,5,0,0,0,7.72,11a5.34,5.34,0,0,1,1.14-.17,2,2,0,0,1,1.26.46l.71.68,1.29,1.29,1.12-1.11-1.16-1.16h0l-.83-.84C10.31,9,10.73,8.57,11,7.71a4.83,4.83,0,0,0,.16-1.15A4.56,4.56,0,0,0,6.56,2Zm0,7.66a3.1,3.1,0,1,1,3.1-3.1,3.1,3.1,0,0,1-3.1,3.1Z",
  transform: "translate(-2 -2)"
})));

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.5 0 12 11.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.626907aa.svg";
export { ForwardRef as ReactComponent };